<div class="dialog-letter">
<h1 mat-dialog-title>{{ 'newsletter.title' | t }}</h1>
<mat-dialog-content class="mat-typography">
  @if (sent) {
    <div class="alert alert-success" id="newsletterSent">
      <p class="mb-0">{{ 'newsletter.checkInbox' | t }}</p>
    </div>
  } @else {
    <h3>
      {{ 'newsletter.intro' | t }}
    </h3>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field>
        <input matInput type="email" [placeholder]="'common.emailPlaceholder' | t" formControlName="email" />
      </mat-form-field>

      <mat-slide-toggle formControlName="partnerOffers" id="newsletterPartnerOffers"><span>{{ 'consents.partnerOffers' | t }}</span></mat-slide-toggle>

      <p class="mt-3">{{ 'newsletter.doubleOptIn' | t }}</p>
      @if (error) {
        <div class="alert alert-danger">{{ error }}</div>
      }
      <p>{{ 'common.privacyAck' | t }} <a class="verySmallText" routerLink="privacyPolicy" (click)="close()">{{ 'common.privacyPolicyLink' | t }}</a></p>
      <h5>
        {{ 'newsletter.unsubscribeLink' | t }} <a href="javascript:void(0)" (click)="openDialogNewsLetterDisable()">{{ 'newsletter.here' | t }}</a>.
      </h5>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button type="button" (click)="close()">{{ 'common.close' | t }}</button>
  @if (!sent) {
    <button type="button" [disabled]="form.invalid || loading" (click)="submit()" cdkFocusInitial mat-raised-button id="newsletterSubmit">{{ 'common.validate' | t }}</button>
  }
</mat-dialog-actions>
</div>
